import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/atoms/Avatar/Avatar";
import { Button } from "@/components/ui/atoms/Button/Button";
import { Label } from "@/components/ui/atoms/Label/Label";
import { CiviliteEnum, UserProfile } from "@/types/settings.types";

type AdminSettingsUserInformationsReadonlyProps = {
  setEditMode: (value: boolean) => void;
  userProfile: UserProfile;
}

const AdminSettingsUserInformationsReadonly = ({ setEditMode, userProfile }: AdminSettingsUserInformationsReadonlyProps): JSX.Element => {

  const getCivilite = (civilite: CiviliteEnum): string => {
    if (civilite === CiviliteEnum.HOMME) return 'M.';
    return 'Mme.';
  }

  return userProfile && (
    <div className="flex flex-col p-2w gap-2w bg-neutral-100">
      <div className="flex flex-col gap-2w md:flex-row md:h-full">
        {/* <div className="flex flex-col items-center justify-center gap-4w p-2w w-full rounded-2xl bg-white md:px-4w md:w-fit md:h-full">
          <Avatar className="w-[160px]">
            <AvatarImage src="https://github.com/shadcn.png" alt="@shadcn" />
            <AvatarFallback>Avatar</AvatarFallback>
          </Avatar>
        </div> */}
        <div className="flex flex-col gap-2w md:w-full">
          <div className="flex flex-col p-2w w-full rounded-2xl bg-white">
            <span className="text-header6">{userProfile.firstName} {userProfile.lastName}</span>
          </div>
          <div className="flex flex-col gap-4w p-2w w-full rounded-2xl bg-white">
            <h2 className="text-subtitle1">Informations complémentaires</h2>
            {userProfile.birthday && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Date de naissance</Label>
              <span className="text-body1">{new Date(parseInt(userProfile.birthday)).toLocaleDateString()}</span>
            </div>}
            {userProfile.postalAddress.address && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Adresse</Label>
              <span className="text-body1">{userProfile.postalAddress.address}</span>
            </div>}
            {userProfile.postalAddress.zipcode && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Code Postal</Label>
              <span className="text-body1">{userProfile.postalAddress.zipcode}</span>
            </div>}
            {userProfile.postalAddress.city && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Ville</Label>
              <span className="text-body1">{userProfile.postalAddress.city}</span>
            </div>}
            {userProfile.postalAddress.country && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Pays</Label>
              <span className="text-body1">{userProfile.postalAddress.country}</span>
            </div>}
            {/* {UserProfile.email1 && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Email 1</Label>
              <span className="text-body1">{UserProfile.email1}</span>
            </div>} */}
            {/* {UserProfile.email2 && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Email 2</Label>
              <span className="text-body1">{UserProfile.email2}</span>
            </div>} */}
            {/* {UserProfile.telephoneFixe && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Téléphone fixe</Label>
              <span className="text-body1">{UserProfile.telephoneFixe}</span>
            </div>} */}
            {/* {UserProfile.telephonePortable && <div className="flex flex-col gap-1w">
              <Label className="text-subtitle1">Téléphone mobile</Label>
              <span className="text-body1">{UserProfile.telephonePortable}</span>
            </div>} */}
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-2w p-2w w-full rounded-2xl bg-white">
        <Button onClick={() =>setEditMode(true)} className="w-fit" type="button">Modifier les informations</Button>
      </div>
    </div>
  )
}

export default AdminSettingsUserInformationsReadonly;